var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLayoutList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-txt-unselected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-txtlist-black",
    d: "M18.7222 10.7778H12.6111M18.7222 15.6667H12.6111M18.7222 5.88889H12.6111M8.33333 1L8.33333 23M6.86667 1H17.1333C19.1869 1 20.2136 1 20.998 1.39964C21.6879 1.75118 22.2488 2.31211 22.6004 3.00203C23 3.78638 23 4.81314 23 6.86667V17.1333C23 19.1869 23 20.2136 22.6004 20.998C22.2488 21.6879 21.6879 22.2488 20.998 22.6004C20.2136 23 19.1869 23 17.1333 23H6.86667C4.81314 23 3.78638 23 3.00203 22.6004C2.31211 22.2488 1.75118 21.6879 1.39964 20.998C1 20.2136 1 19.1869 1 17.1333V6.86667C1 4.81314 1 3.78638 1.39964 3.00203C1.75118 2.31211 2.31211 1.75118 3.00203 1.39964C3.78638 1 4.81314 1 6.86667 1Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayoutList);
export default __webpack_public_path__ + "static/media/icon-layout-list.073ebe2f370dcd0a48ae2ba415aca258.svg";
export { ForwardRef as ReactComponent };